import { submitAssignment, getAssignment, resubmitAssignment } from "../services/assignmentService";

export const submitAssignmentAction = (formData) => (dispatch) => {
    dispatch(request());
    return submitAssignment(formData)
        .then((response) => {
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            dispatch(failure(error.toString()));
            throw error;
        });

    function request() {
        return { type: "SUBMIT_ASSIGNMENT_REQUEST" };
    }

    function success(response) {
        return { type: "SUBMIT_ASSIGNMENT_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "SUBMIT_ASSIGNMENT_FAILURE", payload: error };
    }
};

export const getAssignmentAction = (courseId, moduleId, sectionId) => (dispatch) => {
    dispatch(request());
    return getAssignment(courseId, moduleId, sectionId)
        .then((response) => {
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            dispatch(failure(error.toString()));
            throw error;
        });

    function request() {
        return { type: "GET_ASSIGNMENT_REQUEST" };
    }

    function success(response) {
        return { type: "GET_ASSIGNMENT_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "GET_ASSIGNMENT_FAILURE", payload: error };
    }
};

export const resubmitAssignmentAction = (assignmentId, formData) => (dispatch) => {
    dispatch(request());
    return resubmitAssignment(assignmentId, formData)
        .then((response) => {
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            dispatch(failure(error.toString()));
            throw error;
        });

    function request() {
        return { type: "RESUBMIT_ASSIGNMENT_REQUEST" };
    }

    function success(response) {
        return { type: "RESUBMIT_ASSIGNMENT_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "RESUBMIT_ASSIGNMENT_FAILURE", payload: error };
    }
};
